import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react';

// Added context to prevent the app from closing when bottom sheet is open

interface BottomSheetState {
  isBottomSheetOpen: boolean;
  setIsBottomSheetOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const BottomSheetContext = createContext<BottomSheetState>(null!);

export const useBottomSheetContext = () => {
  const context = useContext(BottomSheetContext);
  if (!context) {
    throw new Error(
      'useBottomSheetContext must be used within a BottomSheetProvider',
    );
  }
  return context;
};

export const BottomSheetProvider = ({ children }: PropsWithChildren) => {
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);

  const value = useMemo(
    () => ({
      isBottomSheetOpen,
      setIsBottomSheetOpen,
    }),
    [isBottomSheetOpen],
  );

  return (
    <BottomSheetContext.Provider value={value}>
      {children}
    </BottomSheetContext.Provider>
  );
};
